import reducer from './templates.reducer';
export default {
  reducer,
};
